import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { 
  LayoutDashboard, 
  Briefcase, 
  BarChart3, 
  FolderKanban, 
  Settings, 
  Share2, 
  Image,
  LogOut,
  Menu,
  X,
  Search,
  ImageIcon,
  FileText,
  MessageSquare,
  BookOpen,
  Users
} from 'lucide-react';
import { Button } from '../../components/ui/button';

const AdminDashboard = ({ children }) => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const menuItems = [
    { icon: LayoutDashboard, label: 'Overview', path: '/admin/dashboard' },
    { icon: ImageIcon, label: 'Hero Section', path: '/admin/hero' },
    { icon: Briefcase, label: 'Services', path: '/admin/services' },
    { icon: Briefcase, label: 'Service Details', path: '/admin/service-details' },
    { icon: ImageIcon, label: 'Services Page', path: '/admin/services-page' },
    { icon: FileText, label: 'About Page', path: '/admin/about' },
    { icon: BookOpen, label: 'Blog Manager', path: '/admin/blogs' },
    { icon: BarChart3, label: 'Statistics', path: '/admin/stats' },
    { icon: FolderKanban, label: 'Projects', path: '/admin/projects' },
    { icon: MessageSquare, label: 'Contact Submissions', path: '/admin/contact-submissions' },
    { icon: Users, label: 'Inventory Leads', path: '/admin/inventory-leads' },
    { icon: Settings, label: 'Site Settings', path: '/admin/settings' },
    { icon: Search, label: 'SEO & Analytics', path: '/admin/seo' },
    { icon: Share2, label: 'Social Media', path: '/admin/social' },
    { icon: Image, label: 'Media Library', path: '/admin/media' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Navbar */}
      <nav className="bg-white border-b border-gray-200 fixed w-full z-30 top-0">
        <div className="px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              {sidebarOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
            <h1 className="text-2xl font-light text-[#2d2d2d]">Reagle CMS</h1>
          </div>
          
          <div className="flex items-center gap-4">
            <Link to="/" target="_blank">
              <Button variant="outline" className="rounded-lg">
                View Website
              </Button>
            </Link>
            <div className="flex items-center gap-2">
              <span className="text-sm text-[#2d2d2d]">Welcome, {user?.username}</span>
              <Button
                onClick={handleLogout}
                variant="ghost"
                className="rounded-lg text-red-600 hover:text-red-700 hover:bg-red-50"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Logout
              </Button>
            </div>
          </div>
        </div>
      </nav>

      {/* Sidebar */}
      <aside
        className={`fixed left-0 top-16 h-[calc(100vh-4rem)] bg-white border-r border-gray-200 transition-all duration-300 z-20 ${
          sidebarOpen ? 'w-64' : 'w-0 overflow-hidden'
        }`}
      >
        <nav className="p-4 space-y-2">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-[#2d2d2d] hover:bg-[#0A1A50]/10 hover:text-[#0A1A50] transition-all duration-200 group"
            >
              <item.icon className="w-5 h-5 group-hover:scale-110 transition-transform" />
              <span className="font-light">{item.label}</span>
            </Link>
          ))}
        </nav>
      </aside>

      {/* Main Content */}
      <main
        className={`pt-20 transition-all duration-300 ${
          sidebarOpen ? 'ml-64' : 'ml-0'
        }`}
      >
        <div className="p-6">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminDashboard;